{
    "button.copy": "Salinan",
    "button.email": "Surel",
    "button.share": "Membagikan",
    "button.sms": "SMS",
    "footer.poweredBy": "Didukung oleh <linkText>Ice Cream Social<\/linkText>",
    "footer.privacyPolicy": "Kebijakan pribadi",
    "footer.termsAndConditions": "Syarat dan ketentuan",
    "offer.hint": "Saat {conversionGoal, plural, one {# teman melakukan pembelian } two {# teman melakukan pembelian } few {# teman melakukan pembelian } many {# teman melakukan pembelian } other {# teman melakukan pembelian }} , Anda akan menerima hadiah !",
    "optInMessage": "Untuk berpartisipasi dan berbagi dengan teman Anda, beri tahu kami cara menghubungi Anda dengan pembaruan penawaran dan hadiah",
    "order.confirmed": "Pesanan # {orderId} dikonfirmasi!",
    "order.details": "Lihat Detail Pesanan",
    "share.email.duplicateError": "Ups! Anda sudah menambahkan email itu.",
    "share.email.heading": "Undang teman melalui email",
    "share.email.inputLabel": "alamat email teman",
    "share.email.inputSubmit": "Memasuki",
    "share.email.invitesSubmit": "Kirim Undangan",
    "share.email.moreOptions": "Opsi Berbagi Lainnya",
    "share.email.subheading": "Masukkan alamat email teman Anda di bawah ini",
    "share.general.help": "<bold> Kesulitan? <\/bold> Aplikasi mungkin tidak terbuka jika tidak dipasang di perangkat Anda, coba gunakan <bold2> Bagikan <\/bold2> melalui tautan pribadi Anda",
    "share.general.linkLabel": "Gunakan tautan pribadi Anda untuk berbagi di mana saja",
    "share.general.otherOptions": "Atau bagikan sekarang di platform ini",
    "thankyou.dismissCTA": "Membubarkan",
    "thankyou.heading": "Terima kasih telah berbagi!",
    "thankyou.message": "Anda seorang juara! Kami akan mengirimkan pembaruan tentang kemajuan hadiah Anda ke kotak masuk Anda.",
    "thankyou.reminder": "Ingatlah bahwa Anda selalu dapat meninjau kembali penawaran ini nanti jika ingin terus berbagi.",
    "thankyou.shareCTA": "Lanjutkan Berbagi",
    "unlock.consentExplanation": "Kami akan menghubungi Anda menggunakan informasi yang Anda berikan. Anda dapat berhenti berlangganan kapan saja, tetapi Anda mungkin melewatkan pembaruan tentang penawaran Anda",
    "unlock.consentPolicyExplanation": "Kami menghargai privasi Anda. Untuk mempelajari bagaimana informasi Anda digunakan, baca <linkText> Kebijakan Privasi dan Cookie <\/linkText>",
    "unlock.emailConsentOptIn": "Email saya pembaruan",
    "unlock.error.invalidEmail": "tolong masukkan email yang benar",
    "unlock.error.noConsent": "Harap setujui komunikasi email untuk berpartisipasi dalam penawaran ini",
    "unlock.input": "Alamat email anda",
    "unlock.label": "Aktifkan Penawaran",
    "share.general.copySuccess": "✨ Tautan disalin!"
}